import IService from '../IService';

/**
 * @namespace app.api.waveform
 */
export default IService.extend({
  getSourceType(asset) {
    if (
      asset.metadata.assetType === 'AUDIO' &&
      asset.metadata.assetSubType === 'BG_MUSIC'
    ) {
      return 'BG_MUSIC';
    } else if ('VIDEO_SEGMENT' === asset.metadata.assetType) {
      return 'FRAGMENT';
    } else if (asset.metadata.assetSubType === 'SYNTHESIZED_SPEECH') {
      return 'SYNTHESIZED_SPEECH';
    } else {
      return 'NARRATION';
    }
  },

  check(asset) {
    return new Promise((resolve, reject) => {
      const waveformSource = this.getSourceType(asset);
      const waveformSourceId = asset.metadata.assetUUID;

      $.ajax({
        url: app.apiUrl(
          `/api/v1/waveform/${waveformSource}/${waveformSourceId}`
        ),
        type: 'GET',

        error: (jqXHR, textStatus) => {
          if (textStatus !== 'abort') {
            reject(this.createError(jqXHR));
          }
        },

        dataType: 'json',
        success: (res) => {
          resolve(res);
        },
      });
    });
  },

  create(asset) {
    return new Promise((resolve, reject) => {
      const payload = {
        waveformSourceId: asset.metadata.assetUUID,
        waveformSource: this.getSourceType(asset),
      };

      $.ajax({
        url: app.apiUrl('/api/v1/waveform'),
        type: 'POST',
        contentType: 'application/json',
        data: JSON.stringify(payload),

        error: (jqXHR, textStatus) => {
          if (textStatus !== 'abort') {
            reject(this.createError(jqXHR));
          }
        },

        dataType: 'json',
        success: (res) => {
          resolve(res);
        },
      });
    });
  },
});
